import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class TextHelper {
    public getSanitizedUpdateText(text: string): string {
        if (!text) return text;
        // Matches: (Leading/trailing spaces around line breaks, Single or multiple \r\n or \n, Any extra spaces mixed in)
        let sanitizedText = text.replace(/[\s\r\n]*[\r\n]+[\s\r\n]*/g, ' ');

        // Split by any whitespace (space, tab, linebreak, etc.) and remove empty strings
        sanitizedText = sanitizedText
            .split(/\s+/)
            .filter(part => part)
            .join(' ');

        // Adds trailingSpace if had one before
        if (/\s$/.test(text)) sanitizedText += ' ';

        return sanitizedText;
    }
}